import React from 'react';
import PropTypes from 'prop-types';
import {ConnectedRouter} from 'connected-react-router';

export const EnhancedRouter = ({history, routes}) => (
  <ConnectedRouter history={history}>{routes}</ConnectedRouter>
);

EnhancedRouter.propTypes = {
  history: PropTypes.object.isRequired,
  routes: PropTypes.object.isRequired,
};

export default EnhancedRouter;
